import { render, staticRenderFns } from "./AiConfigSimple.vue?vue&type=template&id=29a972be&scoped=true"
import script from "./AiConfigSimple.vue?vue&type=script&lang=js"
export * from "./AiConfigSimple.vue?vue&type=script&lang=js"
import style0 from "./AiConfigSimple.vue?vue&type=style&index=0&id=29a972be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a972be",
  null
  
)

export default component.exports